import { render } from "./WorkspaceInformation.vue?vue&type=template&id=375b86f2"
import script from "./WorkspaceInformation.vue?vue&type=script&lang=js"
export * from "./WorkspaceInformation.vue?vue&type=script&lang=js"

import "./WorkspaceInformation.vue?vue&type=style&index=0&id=375b86f2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__